module.exports = __webpack_public_path__ + "static/media/05_1440.6637dcea.jpeg";